import { type ComponentProps, type ReactNode, forwardRef } from 'react';

import classNames from 'classnames';

import {
  FormInput,
  FormInputIcon,
  IconSearch,
} from '@spotify-internal/encore-web';

import styles from './SearchField.module.css';

export type SearchFieldProps = Omit<ComponentProps<typeof FormInput>, 'as'> & {
  trailing?: ReactNode;
};

export const SearchField = forwardRef<HTMLInputElement, SearchFieldProps>(
  ({ className, size = 'small', style, trailing, ...props }, ref) => (
    <div className={styles.wrapper} style={style}>
      <FormInputIcon
        iconLeading={
          <IconSearch size={size === 'small' ? 'small' : 'medium'} />
        }
      >
        <FormInput
          ref={ref}
          className={classNames(styles.input, className, {
            [styles.inputWithTrailing]: Boolean(trailing),
          })}
          size={size}
          data-track-source-anchor="65fe608c4e;search-field-form-input" {...props}
        />
      </FormInputIcon>
      {trailing && <div className={styles.trailing}>{trailing}</div>}
    </div>
  ),
);

SearchField.displayName = 'SearchField';
